import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SmartLabelService } from '../components/smart-label/smart-label.service';
import { Page } from '../interfaces/page';
import { LayoutService } from '../layout/layout.service';
import { GatemanService } from './gateman.service';
import { PageService } from './page.service';

@Injectable({
  providedIn: 'root'
})
export class PageLookupService {

  constructor(
    private layoutService: LayoutService,
    private gatemanService: GatemanService,
    private router: Router,
    private pageService: PageService,
    private smartLabelService: SmartLabelService) { }

  /**
   * [resolvePage used - to load the page depedning on parameters in route]
   * @param  route [routeSnapshot route for page lookup is to be done ]
   * @param  state [RouterStateSnapshot of route ]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
   */
  public resolvePage(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const diLayout = this.pageService.diLayout;
    const nav = this.router.getCurrentNavigation();
    // console.log('nav', nav);
    const routeData = (nav && nav.extras && nav.extras.hasOwnProperty('state')) ? nav.extras.state : {};
    this.pageService.routeData = routeData;
    let page: Page = {} as Page;
    let alias;

    // If deactivated , load first page.
    if (this.layoutService.vdi.status === 'deactivated') {
      const firstPage = this.lookup(diLayout.pages);
      if (firstPage.alias) {
        this.redirectToAlias(this.gatemanService.getLandingPageRoute(state.url), firstPage.alias);
      }
      return firstPage;
    }

    // Fetch Alias
    if (route.data && route.data.routeException) {
      alias = this.searchAlias(state.url);
    } else {
      alias = route.params.alias;
    }
    // If alias is not found, redirect to first page alias.
    if (!alias) {
      const firstPage = this.lookup(diLayout.pages);
      if (firstPage.alias) {
        this.redirectToAlias(this.gatemanService.getLandingPageRoute(state.url), firstPage.alias);
      }
      return firstPage;
    }
    this.pageService.pageAlias = alias;
    this.pageService.detailPageAlias = '';
    if (diLayout.hasOwnProperty('pages')) {
      page = this.lookup(diLayout.pages, alias);
    }
    const mode = this.pageService.getPageMode(page);
    const detailAlias = route.queryParams.detail;
    if (detailAlias) {

      this.pageService.detailPageAlias = alias;

      // Only for smartlabel, push detail pages runtime
      if (mode === 'smartlabel') {
        // Set Smartlabel Config
        this.smartLabelService.smartLabelConfig = this.smartLabelService.getSmartlabelConfig(page);
        // console.log(this.smartLabelService.smartLabelConfig);
        // Push Detail Pages
        const subpages = this.smartLabelService.getDetailPages(detailAlias);
        // console.log(subpages);
        // console.log(page);

        //NOTE: UPDATED BY NEILC
        page.pages ? page.pages : [];

        page.pages = subpages;
        // if (page.pages && Array.isArray(page.pages)) {
        //   if (page.pages.length === 0) {
        //     page.pages.push(...subpages);
        //   }
        // } else {
        //   page.pages = [...subpages];
        // }
      }
      if (page.hasOwnProperty('pages')) {
        page = this.lookup(page.pages, detailAlias);
      }
    }
    // TODO: HANDLE fails on sb/:iid/p/alias
    // console.log(page);
    return JSON.parse(JSON.stringify(page));
  }

  /**
   * [ Given url and alias of page, redirects to p/page_alias ]
   * @param  url   [Root url without page_alias]
   * @param  alias [page alias]
   * @return       [Nothing]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
   */
  redirectToAlias(url: string, alias: string) {
    this.router.navigate([url, 'p', alias], { queryParamsHandling: 'merge' });
  }

  /**
   * [lookup - Execute page lokup and returns page]
   * @param  alias [optional alias of a page ]
   * @return       [page or blank object if page is not found]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
   */
  lookup(pages: Array<Page> = [], alias?: string): Page {
    // console.log(pages);
    // console.log('alias', alias)
    // console.log(`lookup: ${alias}`);
    // console.log('lookup pages', pages);
    let page: Page = {} as Page;
    if (alias) {
      page = this.pageService.pageLookup(alias, pages);
    } else {
      if (pages && pages.length > 0) {
        page = this.pageService.pageLookup('', pages, 1);
      }
    }
    return page;
  }

  /**
   * [in case of route Exception find alias manually from url]
   * @param  url [url string]
   * @return     [alias found in url or blank]
   * @author - SwapnilP
   * @task - QLIKTAG-2925
   */
  searchAlias(url: string): string {
    url = url.split(/[?|#]/)[0];
    const segments = url.split('/');
    const index = segments.indexOf('p');
    let result = '';
    if (index > -1) {
      if ((index + 1) <= segments.length) {
        result = segments[index + 1];
      }
    }
    return result;
  }
}
